module.exports = __webpack_public_path__ + "assets/img/openproject.ec3f5883.png";